import { __makeTemplateObject } from "tslib";
import styled from "@emotion/styled/macro";
export var BasicLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 0.88em;\n    line-height: 1.6;\n    cursor: pointer;\n"], ["\n    font-size: 0.88em;\n    line-height: 1.6;\n    cursor: pointer;\n"])));
var templateObject_1;
